<template>
    <div id="plannerAssignStudent" class=" ">
        <div class="container admin-wrap" style="margin-top: 10px;">
            <div class="row header mb-5">
                <div class="col-lg-5 ">
                    <h4 class="text-left mb-3">{{ lang('Goal Planner') }} </h4>
                </div>
                <div class="col-lg-24">
                    <div class="Class search">
                        <div class="col-lg-24 text-right actionDiv">
                            <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select"
                                       @change="ClassChange()" style="margin-right: 10px;" id="ddlClassID">
                                <el-option
                                        v-for="item in ddlClassList"
                                        :key="item.PK_Semester_ID + ',' + item.SC_FK_CourseID + ',' + item.CLS_ClassName+ ',' + item.PK_Class_ID"
                                        :label="item.CLS_ClassName + ' (' + item.SMT_Year + ')' + item.CLS_Batch "
                                        :value="item.PK_Semester_ID + ',' + item.CLS_ClassName + ',' + item.SC_FK_CourseID + ',' + item.SMT_Year + ',' + item.PK_Class_ID+ ',' + item.CRS_Level">
                                </el-option>
                            </el-select>
                            <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select"
                                       @change="SelectStudent()" style="margin-right: 10px;" id="ddlClassID">
                                <el-option
                                        v-for="item in ddlStudentList"
                                        :key="item.Student_ID"
                                        :label="item.Student_Name"
                                        :value="item.Student_ID">
                                </el-option>
                            </el-select>
                            <b-button variant="" style="margin-right: 10px;" @click="resetStudent()"
                                      v-if="ddlStudent!==''">
                                Reset Student
                            </b-button>
                            <b-button variant="success" style="margin-right: 10px;" @click="SaveClassGoals()">
                                {{ lang('Save') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>

            <b-tabs content-class="mt-3">
                <!--New Class Goals--------------------------------------------------------------------------------------------------------------------------------------------------------------------->
                <b-tab :title="lang('New Class goals')" active>

                    <div class="empty-list_image" v-if="currentClsID===''">
                        <strong>{{ lang('Select a class to start') }}...</strong>
                        <img src="../assets/notfound.png"/>
                    </div>
                    <div class=" formDiv" v-else>
                        <div class="Domains" role="tablist" v-for="domain in ddlGoalsListDomain">
                            <b-card no-body class="mb-2 border-0 border-bottom">

                                <b-card-header header-tag="header" class="p-1 box purple border-0" role="tab">
                                    <K2Row space-between="true" class="p-2">
                                        <K2Row align="center"
                                               v-b-toggle="'my-collapse'+ddlGoalsListDomain.indexOf(domain)">
                                            <K2Icon color="black" name="add" class="when-closed me-2"
                                                    :font-size="uiVariable.fontSize.md"
                                                    style="line-height: 16px"/>
                                            <K2Icon color="black" name="remove" class="when-open me-2"
                                                    :font-size="uiVariable.fontSize.md"
                                                    style="line-height: 16px"/>
                                            <a> {{ domain }}</a>
                                        </K2Row>

                                        <K2Row space-between="true" class="when-open" style="width:280px"
                                               v-if="!studentMode">
                                            <span style="width:70px">{{lang("Term 1")}}</span>
                                            <span style="width:70px">{{lang("Term 2")}}</span>
                                            <span style="width:70px">{{lang("Term 3")}}</span>
                                            <span style="width:70px">{{lang("Term 4")}}</span>
                                        </K2Row>

                                        <K2Row space-between="true" class="when-open" style="width:560px"
                                               v-if="studentMode">
                                            <span style="width:140px">{{lang("Term 1")}}</span>
                                            <span style="width:140px">{{lang("Term 2")}}</span>
                                            <span style="width:140px">{{lang("Term 3")}}</span>
                                            <span style="width:140px">{{lang("Term 4")}}</span>
                                        </K2Row>

                                    </K2Row>
                                </b-card-header>
                                <b-collapse v-bind:id="'my-collapse'+ddlGoalsListDomain.indexOf(domain)"
                                            visible
                                            accordion="my-accordion"
                                            role="tabpanel">
                                    <b-card-body>
                                        <PlannerTable
                                                v-bind:domainGoalList="ddlGoalsList.filter(n => n.PlnMasDomain === domain)"
                                                v-bind:goalRefresh="goalRefresh"
                                                v-bind:ddlTermGoalsLists="[ddlTerm1CombinedGoalsList,ddlTerm2CombinedGoalsList,ddlTerm3CombinedGoalsList,ddlTerm4CombinedGoalsList]"
                                                v-bind:ddlTermClassGoalsLists="[ddlTerm1LevelGoalsList,ddlTerm2LevelGoalsList,ddlTerm3LevelGoalsList,ddlTerm4LevelGoalsList]"
                                                v-bind:ddlStudentTermGoalsLists="[ddlTerm1StuGoalsList,ddlTerm2StuGoalsList,ddlTerm3StuGoalsList,ddlTerm4StuGoalsList]"
                                                v-bind:studentMode="studentMode"
                                                v-on:termGoalChange="termGoalChange"
                                                v-on:studentTermGoalChange="studentTermGoalChange"
                                                :key="goalRefresh+100"
                                        />
                                    </b-card-body>

                                </b-collapse>

                            </b-card>
                        </div>
                    </div>
                </b-tab>
                <!--Other Goals--------------------------------------------------------------------------------------------------------------------------------------------------------------------->
                <b-tab :title="lang('Other Goals')">
                    <div class="empty-list_image" v-if="currentClsID===''">
                        <strong>{{ lang('Select a class to start') }}...</strong>
                        <img src="../assets/notfound.png"/>
                    </div>

                    <div class="row">

                        <div class="col-lg-12 text-left">
                            <el-button type="primary" class="mt-2 mb-2" @click="AddCustomGoals()">
                                {{ lang('Add Custom Goals') }}
                            </el-button>
                        </div>
                        <div v-if="ddlCustomGoalList.length">
                            <div class=" formDiv">
                                <div class="Domains" role="tablist" v-for="domain in ddlCustomGoalDomainList">
                                    <b-card no-body class="mb-2 border-0 border-bottom">
                                        <b-card-header header-tag="header" class="p-1 box purple border-0" role="tab">
                                            <K2Row space-between="true" class="p-2">
                                                <K2Row align="center"
                                                       v-b-toggle="'my-collapse'+ddlCustomGoalDomainList.indexOf(domain)">
                                                    <K2Icon color="black" name="add" class="when-open me-2"
                                                            :font-size="uiVariable.fontSize.md"
                                                            style="line-height: 16px"/>
                                                    <K2Icon color="black" name="remove" class="when-closed me-2"
                                                            :font-size="uiVariable.fontSize.md"
                                                            style="line-height: 16px"/>
                                                    <a> {{ domain }}</a>
                                                </K2Row>

                                                <K2Row space-between="true" class="when-open" style="width:280px">
                                                    <span style="width:70px">{{lang("Term 1")}}</span>
                                                    <span style="width:70px">{{lang("Term 2")}}</span>
                                                    <span style="width:70px">{{lang("Term 3")}}</span>
                                                    <span style="width:70px">{{lang("Term 4")}}</span>
                                                </K2Row>

                                            </K2Row>
                                        </b-card-header>
                                        <b-collapse v-bind:id="'my-collapse'+ddlCustomGoalDomainList.indexOf(domain)"
                                                    visible accordion="my-accordion"
                                                    role="tabpanel">
                                            <b-card-body>
                                                <data-tables
                                                        :data="ddlCustomGoalList.filter(n => n.PlnCusDomain === domain) ">
                                                    <el-table-column v-for="goal in CustomGoalInfo"
                                                                     :prop="goal.prop"
                                                                     :label="goal.label"
                                                                     :key="goal.prop">
                                                    </el-table-column>

                                                    <el-table-column id="Term1c" label="" width="70px">
                                                        <template slot-scope="scope">
                                                            <K2Row justify_content="center">
                                                                <el-checkbox v-model="scope.checked"
                                                                             @change="changeSelectionCus(scope.row.PlnCusID,1,scope.checked)"
                                                                             :key="goalRefresh"
                                                                             :checked="ddlTerm1CusGoalsList.indexOf(scope.row.PlnCusID) !== -1">
                                                                </el-checkbox>
                                                            </K2Row>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column id="Term2c" label="" width="70px">
                                                        <template slot-scope="scope">
                                                            <K2Row justify_content="center">
                                                                <el-checkbox v-model="scope.checked"
                                                                             @change="changeSelectionCus(scope.row.PlnCusID,2,scope.checked )"
                                                                             :key="goalRefresh"
                                                                             :checked="ddlTerm2CusGoalsList.indexOf(scope.row.PlnCusID) !== -1"></el-checkbox>
                                                            </K2Row>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column id="Term3c" label="" width="70px">
                                                        <template slot-scope="scope" class="text-center">
                                                            <K2Row justify_content="center">
                                                                <el-checkbox v-model="scope.checked"
                                                                             @change="changeSelectionCus(scope.row.PlnCusID,3,scope.checked)"
                                                                             :key="goalRefresh"
                                                                             :checked="ddlTerm3CusGoalsList.indexOf(scope.row.PlnCusID) !== -1">
                                                                </el-checkbox>
                                                            </K2Row>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column id="Term4c" label="" width="70px">
                                                        <template slot-scope="scope" class="text-center">
                                                            <K2Row justify_content="center">
                                                                <el-checkbox v-model="scope.checked"
                                                                             @change="changeSelectionCus(scope.row.PlnCusID,3,scope.checked)"
                                                                             :key="goalRefresh"
                                                                             :checked="ddlTerm4CusGoalsList.indexOf(scope.row.PlnCusID) !== -1">
                                                                </el-checkbox>
                                                            </K2Row>
                                                        </template>
                                                    </el-table-column>

                                                </data-tables>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>


                            </div>

                        </div>


                        <div class="empty-list_image" v-else-if="currentClsID!==''">
                            <strong>{{ lang('No Custom Goals') }}...</strong>
                            <img src="../assets/notfound.png"/>
                        </div>

                    </div>
                </b-tab>

            </b-tabs>


        </div>
        <b-modal id="assignedPlannerModel" size="lg" :title="lang('Custom Goals')" ok-only ok-variant="secondary"
                 ok-title="Cancel"
                 ref="assignedPlannerShowModel" hide-footer>
            <div class="row">
                <div class="row">
                    <label>{{lang('Domain')}}</label>
                    <el-select v-model="selectedCustomDomain"
                               :placeholder="lang('Select Domain')"
                               class="pro-edt-select"
                               style="margin-right: 10px;"
                               id="selectedCustomDomain"
                               @change="generateGoalSelectionList()">
                        <el-option
                                v-for="item in ddlGoalsListDomain"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </div>
                <div class="row">
                    <label>{{lang('Goals')}}</label>
                    <el-select v-model="selectedCustomGoal"
                               :placeholder="lang('Select Goal')"
                               class="pro-edt-select"
                               style="margin-right: 10px;"
                               id="ddlClassID"
                               @change="fetchCustomGoals()">
                        <el-option
                                v-for="item in customGoalSelectionList"
                                :key="item.goal"
                                :label="item.goal"
                                :value="item.goal">
                        </el-option>
                    </el-select>
                    <div class="col-lg-12 divKeyInKeySkillorCld">
                        <label>{{ lang('Learning Goals') }}</label>
                        <input type="text" class="form-control inputKeySkillCLD" v-model="customGoalIndicator"
                               :placeholder="lang('Enter Indicator')">
                    </div>
                    <div class="col-lg-12"
                         v-if="selectedCustomDomain !== '' && selectedCustomGoal !== '' && customGoalIndicator !== ''">
                        <el-button type="primary" class="mt-2 mb-2" @click="insertCustomGoal()">
                            {{ lang('Add') }}
                        </el-button>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div v-if="fetchedCustomGoalList.length>0">
                        <data-tables :data="fetchedCustomGoalList ">
                            <el-table-column v-for="goal in CustomGoalInfo"
                                             :prop="goal.prop"
                                             :label="goal.label"
                                             :key="goal.key">
                            </el-table-column>
                            <el-table-column :label="lang('Assign')" min-width="100px">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click="assignCustomGoal(scope.row)">
                                        <!--                    levelSelect(scope.row.PK_Course_ID,scope.row.CRS_Level,scope.row.ClS_FK_Semester_ID-->
                                        {{lang('Assign')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </data-tables>
                    </div>

                    <div class="empty-list_image" v-else>
                        <strong>{{lang ('No Data Found')}}...</strong>
                        <img src="../assets/notfound.png"/>
                    </div>

                </div>
            </div>
        </b-modal>


    </div>


</template>

<script>
    import DataSource from "../data/datasource";
    import {lang, selectedLocale} from '../locale/index';
    import Vue from 'vue';
    import VueTour from 'vue-tour';
    import K2Row from "../uiComponents/k2Row/k2Row";
    import K2Icon from "../uiComponents/k2Icon/k2MAIcon";
    import uiVariable from "../config/uiVariable";
    import K2ToolTip from "../uiComponents/k2ToolTip/k2ToolTip";
    import Cookies from "js-cookie";
    import PlannerTable from "@/uiComponents/K2PlannerTable/PlannerTable";

    require('vue-tour/dist/vue-tour.css');
    Vue.use(VueTour);

    Vue.component('blog-post', {
        props: ['post'],
    });
    export default {
        name: "PlannerAssignClass",
        components: {K2ToolTip, K2Icon, K2Row, PlannerTable},
        props: ["passTourData"],
        data() {
            return {
                uiVariable: uiVariable,
                currentSemID: '',
                currentClsName: '',
                currentCrsID: '',
                currentSMTYear: '',
                currentClsID: '',
                currentClSLevel: '',
                currentSchID: '',

                ddlClassListAll: [],
                ddlClassList: [],
                ddlClass: '',
                ddlSemesterDetailsList: [],
                ddlSemesterDetails: '',
                TermSemdID: [],

                ddlStudentList: [],
                ddlStudent: '',

                multipleSelection: [],

                ddlGoalsList: [],
                ddlGoalsListDomain: [],

                ddlTerm1LevelGoalsList: [],
                ddlTerm2LevelGoalsList: [],
                ddlTerm3LevelGoalsList: [],
                ddlTerm4LevelGoalsList: [],

                ddlTerm1ClassGoalsList: [],
                ddlTerm2ClassGoalsList: [],
                ddlTerm3ClassGoalsList: [],
                ddlTerm4ClassGoalsList: [],

                ddlTerm1CombinedGoalsList: [],
                ddlTerm2CombinedGoalsList: [],
                ddlTerm3CombinedGoalsList: [],
                ddlTerm4CombinedGoalsList: [],

                ddlTerm1StuGoalsList: [],
                ddlTerm2StuGoalsList: [],
                ddlTerm3StuGoalsList: [],
                ddlTerm4StuGoalsList: [],

                goalsListInfo: [{
                    //   prop: "PlnMasDomain",
                    //   label: "Domain"
                    // }, {
                    //   prop: "PlnMasGoalsITL",
                    //   label: "Goals"
                    // }, {
                    prop: "PlnMasIndicator",
                    label: lang('Indicator')
                    // }, {
                    //   prop: "PlnMasIndicatorType",
                    //   label: "Indicator Type"
                }],

                CustomGoalInfo: [{
                    //   prop: "PlnCusDomain",
                    //   label: "Domain"
                    // }, {
                    //   prop: "PlnCusGoalsITL",
                    //   label: "Goal"
                    // }, {
                    prop: "PlnCusIndicator",
                    label: lang('Indicator')
                }],

                visible: true,
                studentMode: false,
                goalRefresh: 0,


                customGoalDomain: '',
                customGoalGoal: '',

                GoalDomainList: [],


                levelSelected: false,


                selectedCustomDomain: '',
                selectedCustomGoal: '',
                customGoalIndicator: '',
                customGoalSelectionList: [],
                GoalDomainSelectionList: [],

                fetchedCustomGoalList: [],
                ddlCustomGoalDomainList: [],
                ddlCustomGoalList: [],


                ddlTerm1CusGoalsList: [],
                ddlTerm2CusGoalsList: [],
                ddlTerm3CusGoalsList: [],
                ddlTerm4CusGoalsList: [],

            };
        },


        async created() {
            await this.bindClasses();

        },
        async mounted() {
            this.goalsListInfo[0].label = lang("Indicator");
            this.CustomGoalInfo[0].label = lang("Indicator");
        },
        methods: {
            lang,
//--- Set Up for Module-----------------------------------------------------------------------------------------------------------------------------------------------------

            async bindClasses() {
                try {
                    const response = await DataSource.shared.getClassList();
                    if (response) {

                        this.class = response.Table;
                        this.class.forEach(m => {
                            this.ddlClassListAll.push(m);
                        });

                        this.class.forEach(m => {
                            let check = this.ddlClassList.filter(m2 => m2.CLS_ClassName.trim() === m.CLS_ClassName.trim() && m2.PK_Semester_ID === m.PK_Semester_ID && m.SC_FK_CourseID === m2.SC_FK_CourseID && m2.PK_Class_ID === m.PK_Class_ID);
                            if (check.length < 1) {
                                let temp = {
                                    CLS_ClassName: m.CLS_ClassName.trim(),
                                    PK_Semester_ID: m.PK_Semester_ID,
                                    SC_FK_CourseID: m.SC_FK_CourseID,
                                    SMT_Year: m.SMT_Year,
                                    PK_Class_ID: m.PK_Class_ID,
                                    CRS_Level: m.CRS_Level,
                                    CLS_Batch: m.CLS_Batch
                                };

                                this.ddlClassList.push(temp);
                            }
                        });

                    }
                } catch (e) {
                    this.results = e;
                }
            },

            async fetchClassGoals() {
                //get level goals
                this.ddlTerm1LevelGoalsList = await this.getLevelGoals(this.TermSemdID[0]);
                this.ddlTerm2LevelGoalsList = await this.getLevelGoals(this.TermSemdID[1]);
                this.ddlTerm3LevelGoalsList = await this.getLevelGoals(this.TermSemdID[2]);
                this.ddlTerm4LevelGoalsList = await this.getLevelGoals(this.TermSemdID[3]);

                //get class goals
                this.ddlTerm1ClassGoalsList = await this.getClassGoals(this.TermSemdID[0]);
                this.ddlTerm2ClassGoalsList = await this.getClassGoals(this.TermSemdID[1]);
                this.ddlTerm3ClassGoalsList = await this.getClassGoals(this.TermSemdID[2]);
                this.ddlTerm4ClassGoalsList = await this.getClassGoals(this.TermSemdID[3]);

                let combinesGoals = await this.getClassGoalsReworked();
              // console.log(this.ddlTerm1LevelGoalsList);
              // console.log(this.ddlTerm2LevelGoalsList);
              // console.log(this.ddlTerm3LevelGoalsList);
              // console.log(this.ddlTerm4LevelGoalsList);
                // //combined goals
                this.ddlTerm1CombinedGoalsList = combinesGoals[0];
                this.ddlTerm2CombinedGoalsList = combinesGoals[1];
                this.ddlTerm3CombinedGoalsList = combinesGoals[2];
                this.ddlTerm4CombinedGoalsList = combinesGoals[3];

              // this.ddlTerm1CombinedGoalsList = combinedGoals[0];
              // this.ddlTerm2CombinedGoalsList = combinedGoals[0];
              // this.ddlTerm3CombinedGoalsList = combinedGoals[0];
              // this.ddlTerm4CombinedGoalsList = combinedGoals[0];

                //custom goals
                this.ddlTerm1CusGoalsList = await this.getClassCustomGoals(this.TermSemdID[0]);
                this.ddlTerm2CusGoalsList = await this.getClassCustomGoals(this.TermSemdID[1]);
                this.ddlTerm3CusGoalsList = await this.getClassCustomGoals(this.TermSemdID[2]);
                this.ddlTerm4CusGoalsList = await this.getClassCustomGoals(this.TermSemdID[3]);
                this.ddlCustomGoalList = await this.getSaveCustomGoalList();

                this.generateCustomDomainList(this.ddlCustomGoalList);
            },

            async bindSemesterDetails() {
                try {
                    let ddlClassObj = this.ddlClass.split(",");
                    this.ddlSemesterDetailsList = [];

                    const response = await DataSource.shared.getSemesterTermDetailsBySemID(this.currentSemID, '', 'Active');

                    if (response) {
                        this.class = response.Table;
                        this.class.forEach(m => {
                            this.ddlSemesterDetailsList.push(m);
                        });
                    }
                } catch (e) {
                    this.results = e;
                }
                let Term1SemdID = "";
                let Term2SemdID = "";
                let Term3SemdID = "";
                let Term4SemdID = "";

                this.ddlSemesterDetailsList.forEach(semester => {
                    switch (semester.SEMD_DetailName) {
                        case "Term 1":
                            Term1SemdID = semester.PK_SEMD_ID;
                            this.currentSemID = semester.PK_Semester_ID;
                            break;
                        case "Term 2":
                            Term2SemdID = semester.PK_SEMD_ID;
                            break;
                        case "Term 3":
                            Term3SemdID = semester.PK_SEMD_ID;
                            break;
                        case "Term 4":
                            Term4SemdID = semester.PK_SEMD_ID;
                            break;
                    }
                });
                this.TermSemdID.push(Term1SemdID);
                this.TermSemdID.push(Term2SemdID);
                this.TermSemdID.push(Term3SemdID);
                this.TermSemdID.push(Term4SemdID);

            },

            async getPlannerMaster(LevelType) {
                try {
                    let result = [];

                    let IB = "NON IB";

                    if (Cookies.get('schoolSession') === 'SCH201400000553' || Cookies.get('schoolSession') === 'SCH201400000471') {

                        if (LevelType === 'N2' || LevelType === 'K1' || LevelType === 'K2') {
                            IB = "IB";
                        } else if (selectedLocale() === 'CH') {
                            IB = "IB";
                        }
                    }
                    console.log(IB);

                    const response = await DataSource.shared.getPlannerMaster(LevelType, '', '', '', IB);
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerMaster error');
                        } else if (response.code === '2') {
                            console.log('getPlannerMaster no record');
                        } else {
                            result = response.Table;

                        }
                    }

                    return result;
                } catch (e) {
                    this.results = e;
                }
            },

            async getDomainList(LevelType) {
                try {
                    let result = [];

                    const response = await DataSource.shared.getDomainList(this.currentClSLevel);
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerMaster error');
                        } else if (response.code === '2') {
                            console.log('getPlannerMaster no record');
                        } else {
                            result = response.Table;

                        }
                    }
                    this.ddlGoalsListDomain = [];
                    result.forEach(domain => {
                        this.ddlGoalsListDomain.push(domain.PlnMasDomain);
                    });

                } catch (e) {
                    this.results = e;
                }
            },
//--- Class and Student Selection-----------------------------------------------------------------------------------------------------------------------------------------------------

            async ClassChange() {
                this.$vs.loading();

                this.resetAll();
                let classDetails = this.ddlClass.split(",");
                this.currentSemID = classDetails[0];
                this.currentClsName = classDetails[1];
                this.currentCrsID = classDetails[2];
                this.currentSMTYear = classDetails[3];
                this.currentClsID = classDetails[4];
                this.currentClSLevel = classDetails[5];

                //get goal list for table
                this.ddlGoalsList = await this.getPlannerMaster(this.currentClSLevel);

                this.ddlGoalsList.forEach(n => {
                    const pos = this.ddlGoalsListDomain.indexOf(n.PlnMasDomain);
                    if (pos === -1) {
                        this.ddlGoalsListDomain.push(n.PlnMasDomain);
                    }
                });

                //get semdID
                await this.bindSemesterDetails();
                await this.getClassStudentList();
                await this.fetchClassGoals();

                this.studentMode = false;
                this.ddlStudent = '';
                this.elementRefresh();

                this.$vs.loading.close();
            },

            async SelectStudent() {

                this.$vs.loading();
                // this.resetStudent();
                this.studentMode = true;
                this.ddlTerm1ClassGoalsList = await this.getClassGoals(this.TermSemdID[0]);
                this.ddlTerm2ClassGoalsList = await this.getClassGoals(this.TermSemdID[1]);
                this.ddlTerm3ClassGoalsList = await this.getClassGoals(this.TermSemdID[2]);
                this.ddlTerm4ClassGoalsList = await this.getClassGoals(this.TermSemdID[3]);
                this.ddlTerm1StuGoalsList = await this.getStudentGoals(this.TermSemdID[0]);
                this.ddlTerm2StuGoalsList = await this.getStudentGoals(this.TermSemdID[1]);
                this.ddlTerm3StuGoalsList = await this.getStudentGoals(this.TermSemdID[2]);
                this.ddlTerm4StuGoalsList = await this.getStudentGoals(this.TermSemdID[3]);
                // console.log(this.ddlTerm1StuGoalsList);
                // console.log(this.ddlTerm2StuGoalsList);
                // console.log(this.ddlTerm3StuGoalsList);
                // console.log(this.ddlTerm4StuGoalsList);
                //
                this.ddlTerm1CusGoalsList = await this.getStudentCustomGoals(this.TermSemdID[0]);
                this.ddlTerm2CusGoalsList = await this.getStudentCustomGoals(this.TermSemdID[1]);
                this.ddlTerm3CusGoalsList = await this.getStudentCustomGoals(this.TermSemdID[2]);
                this.ddlTerm4CusGoalsList = await this.getStudentCustomGoals(this.TermSemdID[3]);
                this.ddlCustomGoalList = await this.getSaveCustomGoalList();

                this.generateCustomDomainList(this.ddlCustomGoalList);
                this.elementRefresh();
                this.$vs.loading.close();
            },

            async getClassStudentList() {
                try {
                    if (this.ddlClass === '') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select Class...'
                        });
                    } else {

                        this.isLoading = true;
                        this.ddlStudentList = [];
                        const response = await DataSource.shared.getStudentsByClass(this.currentCrsID, this.currentClsID, this.currentSemID);
                        if (response) {
                            if (response.code === '2') {
                                console.log('getPlannerAssignedStudentSummaryByClassSemester no record');
                            } else if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                console.log('getPlannerAssignedStudentSummaryByClassSemester error');
                            } else {
                                this.ddlStudentList = response.Table;
                            }
                        }
                        this.isLoading = false;
                    }
                } catch (e) {
                    this.results = e;
                }
            },

//--- Check Box Toggle Action-----------------------------------------------------------------------------------------------------------------------------------------------------

            changeSelection(Goal, Term, Check) {
                switch (Term) {
                    case 1 :
                        if (Check) {
                            if (this.ddlTerm1CombinedGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm1CombinedGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm1CombinedGoalsList = this.ddlTerm1CombinedGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 2 :
                        if (Check) {
                            if (this.ddlTerm2CombinedGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm2CombinedGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm2CombinedGoalsList = this.ddlTerm2CombinedGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 3:
                        if (Check) {
                            if (this.ddlTerm3CombinedGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm3CombinedGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm3CombinedGoalsList = this.ddlTerm3CombinedGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 4 :
                        if (Check) {
                            if (this.ddlTerm4CombinedGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm4CombinedGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm4CombinedGoalsList = this.ddlTerm4CombinedGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                }
            },

            changeSelectionStudent(Goal, Term, Check) {
                switch (Term) {
                    case 1 :
                        if (Check) {
                            if (this.ddlTerm1StuGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm1StuGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm1StuGoalsList = this.ddlTerm1StuGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 2 :
                        if (Check) {
                            if (this.ddlTerm2StuGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm2StuGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm2StuGoalsList = this.ddlTerm2StuGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 3:
                        if (Check) {
                            if (this.ddlTerm3StuGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm3StuGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm3StuGoalsList = this.ddlTerm3StuGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 4 :
                        if (Check) {
                            if (this.ddlTerm4StuGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm4StuGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm4StuGoalsList = this.ddlTerm4StuGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                }
            },
          async getClassGoalsReworked() {
            try {
              let result = [];
              //crsID, classID, semID,Term1SemdID,Term2SemdID,Term3SemdID,Term4SemdID
              const response = await DataSource.shared.getPlannerAssignedToClassReworked(this.currentCrsID, this.currentClsID, this.currentSemID, this.TermSemdID[0], this.TermSemdID[1], this.TermSemdID[2], this.TermSemdID[3]);
              if (response) {
                if (response.code === '2') {
                  console.log('getPlannerAssignedStudentDetails no record');
                } else if (response.code === '88') {
                  window.location.replace('/');
                } else if (response.code === '99') {
                  console.log('getPlannerAssignedStudentDetails error');
                } else {
                  result = response;

                }
              }
              return result;
            } catch (e) {
              this.results = e;
            }
          },


          async getClassGoals(semID) {
                try {
                    let result = [];

                    const response = await DataSource.shared.getPlannerAssignedToClass(this.currentCrsID, this.currentClsID, semID);
                    if (response) {
                        if (response.code === '2') {
                            console.log('getPlannerAssignedStudentDetails no record');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerAssignedStudentDetails error');
                        } else {
                            response.Table.forEach(m => {
                                let temp = m.PlnClaPlnMasID;
                                result.push(temp);
                            });
                        }
                    }
                    return result;
                } catch (e) {
                    this.results = e;
                }
            },

            async getLevelGoals(semID) {
                try {
                    let result = [];

                    const response = await DataSource.shared.getPlannerAssignedToLevel(this.currentCrsID, semID);
                    if (response) {
                        if (response.code === '2') {
                            console.log('getPlannerAssignedStudentDetails no record');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerAssignedStudentDetails error');
                        } else {
                            response.Table.forEach(m => {
                                let temp = m.PlnCxPlnMasID;
                                result.push(temp);
                            });
                        }
                    }
                    return result;
                } catch (e) {
                    this.results = e;
                }
            },

            async getStudentGoals(termID) {
                try {
                    let result = [];

                    const response = await DataSource.shared.getPlannerAssignedToStudent(this.currentCrsID, this.currentClsID, termID, this.ddlStudent);
                    if (response) {
                        if (response.code === '2') {
                            console.log('getPlannerAssignedStudentDetails no record');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerAssignedStudentDetails error');
                        } else {
                            return response;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },

            async SaveClassGoals() {

                if (this.studentMode === false) {

                    let newPlannerAssignedToSchoolObjJson = {
                        CrsID: this.currentCrsID,
                        classID: this.currentClsID,
                        semID: this.currentSemID,
                        Term1SemdID: this.TermSemdID[0],
                        Term2SemdID: this.TermSemdID[1],
                        Term3SemdID: this.TermSemdID[2],
                        Term4SemdID: this.TermSemdID[3],
                        Term1GoalsList: this.ddlTerm1CombinedGoalsList,
                        Term2GoalsList: this.ddlTerm2CombinedGoalsList,
                        Term3GoalsList: this.ddlTerm3CombinedGoalsList,
                        Term4GoalsList: this.ddlTerm4CombinedGoalsList,

                    };

       
                    const response = await DataSource.shared.savePlannerAssignedToClass(JSON.stringify(newPlannerAssignedToSchoolObjJson));
                    if (response.code === '2') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select Class & Term...'
                        });
                    } else if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === '99') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Class Goals Details: ERROR!!'
                        });
                    } else {
                        this.$notify.info({
                            title: 'Successfully',
                            message: 'Successfully Save...'
                        });
                        await this.fetchClassGoals();

                    }
                    await this.saveCusClass();
                    // await this.fetchClassGoals();
                    

                } else if (this.studentMode === true) {
                    let newPlannerAssignedToStudentObjJson = {
                        CrsID: this.currentCrsID,
                        classID: this.currentClsID,
                        semID: this.currentSemID,
                        StudentID: this.ddlStudent,
                        Term1SemID: this.TermSemdID[0],
                        Term2SemID: this.TermSemdID[1],
                        Term3SemID: this.TermSemdID[2],
                        Term4SemID: this.TermSemdID[3],

                        Term1GoalsList: this.ddlTerm1StuGoalsList,
                        Term2GoalsList: this.ddlTerm2StuGoalsList,
                        Term3GoalsList: this.ddlTerm3StuGoalsList,
                        Term4GoalsList: this.ddlTerm4StuGoalsList

                    };

                    const response = await DataSource.shared.savePlannerAssignedToStudentK2(JSON.stringify(newPlannerAssignedToStudentObjJson));

                    if (response.code === '2') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select Class & Term...'
                        });
                    } else if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === '99') {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Student Goals Details: ERROR!!'
                        });
                    } else {
                        this.$notify.info({
                            title: 'Successfully',
                            message: 'Successfully Save...'
                        });
                    }
                    await this.saveCusStud();

                }
            },

            async resetStudent() {
                this.ddlStudent = "";
                this.ddlTerm1StuGoalsList = [];
                this.ddlTerm2StuGoalsList = [];
                this.ddlTerm3StuGoalsList = [];
                this.ddlTerm4StuGoalsList = [];

                this.ddlTerm1CusGoalsList = [];
                this.ddlTerm2CusGoalsList = [];
                this.ddlTerm3CusGoalsList = [];
                this.ddlTerm4CusGoalsList = [];
                this.ddlCustomGoalList = [];
                this.studentMode = false;
                await this.ClassChange();
            },

            termGoalChange(value) {

                this.changeSelection(value[0], value[1], value[2]);
                

            },

            studentTermGoalChange(value) {

                this.changeSelectionStudent(value[0], value[1], value[2]);

            },

//---Custom Goal Area------------------------------------------------------------------------------------------------------------------

            async AddCustomGoals() {
                const response = await DataSource.shared.getDomainList(this.currentClsID);
                this.GoalDomainSelectionList = response.Table;
                this.$refs.assignedPlannerShowModel.show();
            },

            async generateGoalSelectionList() {

                let customgoalgoallist = this.ddlGoalsList.filter(n => n.PlnMasDomain === this.selectedCustomDomain);
                this.customGoalSelectionList = [];
                // item.PlnMasGoalsITL
                let temp = [];
                let list = [];
                customgoalgoallist.forEach(
                    m => {
                        if (temp.indexOf(m.PlnMasGoalsITL) < 0) {
                            temp.push(m.PlnMasGoalsITL);
                            list.push({"goal": m.PlnMasGoalsITL});
                        }
                    }
                );
                this.customGoalSelectionList = list;


            },

            async fetchCustomGoals() {

                try {

                    this.fetchedCustomGoalList = [];

                    const response = await DataSource.shared.fetchCustomGoals(this.selectedCustomDomain, this.selectedCustomGoal);

                    if (response.code === '3' || response.code === '99') {

                    } else {

                        this.fetchedCustomGoalList = response.Table;

                    }


                } catch (e) {
                    this.results = e;
                }

            },

            async insertCustomGoal() {

                await DataSource.shared.insertCustomGoal(this.selectedCustomDomain, this.selectedCustomGoal, this.customGoalIndicator);
                await this.fetchCustomGoals();
                this.customGoalIndicator = '';

            },

            assignCustomGoal(goal) {
                let existInDB = false;
                this.ddlCustomGoalList.forEach(m => {
                    if (m.PlnCusID === goal.PlnCusID) {
                        existInDB = true;
                    }

                });

                if (!existInDB) {
                    this.ddlCustomGoalList.push(goal);
                } else {
                    this.$notify.error({
                        title: 'Alert',
                        message: 'The goal already exist in the list'
                    });
                }
                if (this.ddlCustomGoalDomainList.indexOf(goal.PlnCusDomain) < 0) {
                    this.ddlCustomGoalDomainList.push(goal.PlnCusDomain);
                }

            },

            generateCustomDomainList(goalList) {
                goalList.forEach(goal => {
                    if (this.ddlCustomGoalDomainList.indexOf(goal.PlnCusDomain) < 0) {
                        this.ddlCustomGoalDomainList.push(goal.PlnCusDomain);
                    }
                });


            },

            changeSelectionCus(Goal, Term, Check) {
                switch (Term) {
                    case 1 :
                        if (Check) {
                            if (this.ddlTerm1CusGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm1CusGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm1CusGoalsList = this.ddlTerm1CusGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 2 :
                        if (Check) {
                            if (this.ddlTerm2CusGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm2CusGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm2CusGoalsList = this.ddlTerm2CusGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 3:
                        if (Check) {
                            if (this.ddlTerm3CusGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm3CusGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm3CusGoalsList = this.ddlTerm3CusGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;
                    case 4 :
                        if (Check) {
                            if (this.ddlTerm4CusGoalsList.indexOf(Goal) === -1) {
                                this.ddlTerm4CusGoalsList.push(Goal);
                            }
                        } else {
                            this.ddlTerm4CusGoalsList = this.ddlTerm4CusGoalsList.filter(function (goal) {
                                return goal !== Goal;
                            });
                        }
                        break;

                }
            },

            async saveCusClass() {
                let newPlannerAssignedToClassObjJson = {
                    ClsID: this.currentClsID,
                    CrsID: this.currentCrsID,
                    semID: this.semID,
                    Term1SemdID: this.TermSemdID[0],
                    Term2SemdID: this.TermSemdID[1],
                    Term3SemdID: this.TermSemdID[2],
                    Term4SemdID: this.TermSemdID[3],
                    Term1GoalsList: this.ddlTerm1CusGoalsList,
                    Term2GoalsList: this.ddlTerm2CusGoalsList,
                    Term3GoalsList: this.ddlTerm3CusGoalsList,
                    Term4GoalsList: this.ddlTerm4CusGoalsList,

                };

                const response = await DataSource.shared.saveCustomPlannerAssignedToClass(JSON.stringify(newPlannerAssignedToClassObjJson));
                if (response.code === '2') {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Please select Class & Term...'
                    });
                } else if (response.code === '88') {
                    window.location.replace('/');
                } else if (response.code === '99') {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Custom Goals Details: ERROR!!'
                    });
                } else {
                    this.$notify.info({
                        title: 'Successfully',
                        message: 'Successfully Save...'
                    });
                }

            },

            async saveCusStud() {
                let newPlannerAssignedToClassObjJson = {
                    ClsID: this.currentClsID,
                    CrsID: this.currentCrsID,
                    semID: this.semID,
                    studID: this.ddlStudent,
                    Term1SemdID: this.TermSemdID[0],
                    Term2SemdID: this.TermSemdID[1],
                    Term3SemdID: this.TermSemdID[2],
                    Term4SemdID: this.TermSemdID[3],
                    Term1GoalsList: this.ddlTerm1CusGoalsList,
                    Term2GoalsList: this.ddlTerm2CusGoalsList,
                    Term3GoalsList: this.ddlTerm3CusGoalsList,
                    Term4GoalsList: this.ddlTerm4CusGoalsList,

                };

                const response = await DataSource.shared.saveCustomPlannerAssignedToStudent(JSON.stringify(newPlannerAssignedToClassObjJson));
                if (response.code === '2') {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Please select Class & Term...'
                    });
                } else if (response.code === '88') {
                    window.location.replace('/');
                } else if (response.code === '99') {
                    this.$notify.error({
                        title: 'Error',
                        message: 'Student Custom Goals Details: ERROR!!'
                    });
                } else {
                    this.$notify.info({
                        title: 'Successfully',
                        message: 'Successfully Save...'
                    });
                }

            },

            async getStudentCustomGoals(semID) {
                try {
                    let result = [];

                    const response = await DataSource.shared.getCustomPlannerAssignedToStudent(this.currentCrsID, this.currentClsID, this.ddlStudent, semID);
                    if (response) {
                        if (response.code === '2') {
                            console.log('getPlannerAssignedStudentDetails no record');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerAssignedStudentDetails error');
                        } else {
                            response.forEach(m => {
                                result.push(m);
                            });
                        }
                    }
                    return result;
                } catch (e) {
                    this.results = e;
                }
            },

            async getClassCustomGoals(semID) {
                try {
                    let result = [];

                    const response = await DataSource.shared.getCustomPlannerAssignedToClass(this.currentCrsID, this.currentClsID, semID);
                    if (response) {
                        if (response.code === '2') {
                            console.log('getPlannerAssignedStudentDetails no record');
                        } else if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('getPlannerAssignedStudentDetails error');
                        } else {
                            response.forEach(m => {
                                result.push(m);
                            });
                        }
                    }
                    return result;
                } catch (e) {
                    this.results = e;
                }

            },

            async getSaveCustomGoalList() {
                try {
                    const response = await DataSource.shared.getSaveCustomGoalList(
                        JSON.stringify(this.ddlTerm1CusGoalsList),
                        JSON.stringify(this.ddlTerm2CusGoalsList),
                        JSON.stringify(this.ddlTerm3CusGoalsList),
                        JSON.stringify(this.ddlTerm4CusGoalsList)
                    );
                    let result = [];
                    result = response.Table;
                    return result;
                } catch (e) {
                    return [];
                }
            },

            elementRefresh() {
                console.log("test");
                this.goalRefresh++;
            },

            resetAll() {
                this.ddlGoalsList = [];
                this.ddlGoalsListDomain = [];
                this.ddlTerm1LevelGoalsList = [];
                this.ddlTerm2LevelGoalsList = [];
                this.ddlTerm3LevelGoalsList = [];
                this.ddlTerm4LevelGoalsList = [];

                this.ddlTerm1ClassGoalsList = [];
                this.ddlTerm2ClassGoalsList = [];
                this.ddlTerm3ClassGoalsList = [];
                this.ddlTerm4ClassGoalsList = [];


                this.ddlTerm1CombinedGoalsList = [];
                this.ddlTerm2CombinedGoalsList = [];
                this.ddlTerm3CombinedGoalsList = [];
                this.ddlTerm4CombinedGoalsList = [];

                this.ddlTerm1CusGoalsList = [];
                this.ddlTerm2CusGoalsList = [];
                this.ddlTerm3CusGoalsList = [];
                this.ddlTerm4CusGoalsList = [];
                this.ddlCustomGoalList = [];
            },


        },


    };

</script>

<style scoped>
    .sc-table {
        margin-top: 0px;
    }

    .sc-table .el-table__header-wrapper {
        display: none !important;
    }


</style>